import selectSelectedProduct from "./selectSelectedProduct";

export default function selectProductImageAngles(state) {
  const selectedProduct = selectSelectedProduct(state);
  return Object.keys(selectedProduct?.images || {});
}
